import { useState, useMemo } from "react";
import { useLang } from "@/i18n/LanguageContext";
import { GALLERY } from "@/data/site";
import { Reveal, Eyebrow } from "@/components/Reveal";
import { Lightbox } from "@/components/Lightbox";
import Seo from "@/components/Seo";

const CATS = ["all", "rooms", "property", "dining", "medjugorje"];

export default function Gallery() {
  const { t, lang } = useLang();
  const [cat, setCat] = useState("all");
  const [lightbox, setLightbox] = useState(null);

  const filtered = useMemo(
    () => (cat === "all" ? GALLERY : GALLERY.filter((g) => g.cat === cat)),
    [cat]
  );

  return (
    <div data-testid="gallery-page" key={lang} className="pt-16 sm:pt-20">
      <Seo title={t.seo.gallery.title} description={t.seo.gallery.desc} />

      <header className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pt-14 sm:pt-20 pb-10">
        <Reveal>
          <Eyebrow>Sobe Bevanda — Međugorje</Eyebrow>
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-[#1F2421]">{t.galleryPage.title}</h1>
          <p className="text-lg sm:text-xl text-[#4A504B] font-light mt-6">{t.galleryPage.lead}</p>
        </Reveal>

        <div className="flex flex-wrap gap-2 mt-10" role="group" aria-label="Gallery categories">
          {CATS.map((c) => (
            <button
              key={c}
              data-testid={`gallery-filter-${c}`}
              onClick={() => setCat(c)}
              aria-pressed={cat === c}
              className={`rounded-full px-4 py-2 text-[13px] font-medium transition-colors duration-200 ${
                cat === c
                  ? "bg-[#4A5D3E] text-[#F9F8F3]"
                  : "border border-[#1F2421]/12 text-[#4A504B] hover:border-[#4A5D3E]/40 hover:text-[#1F2421]"
              }`}
            >
              {t.galleryPage.cats[c]}
            </button>
          ))}
        </div>
      </header>

      <section className="max-w-7xl mx-auto px-4 sm:px-8 lg:px-16 pb-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 [&>button]:mb-5">
          {filtered.map((img, i) => (
            <button
              key={img.src}
              data-testid={`gallery-image-${i}`}
              onClick={() => setLightbox(i)}
              className="group block w-full overflow-hidden rounded-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-[#4A5D3E]"
            >
              <img
                src={img.src}
                alt={img.alt}
                loading="lazy"
                className="w-full object-cover transition-transform duration-700 group-hover:scale-[1.04]"
              />
            </button>
          ))}
        </div>
      </section>

      <Lightbox images={filtered} index={lightbox} onClose={() => setLightbox(null)} onNavigate={setLightbox} />
    </div>
  );
}
